module.exports = __webpack_public_path__ + "static/media/emj14.78c8cb5b.svg";